import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import React from "react";

const  ListContainer = ({children}) => {
  return (
    <Container fluid>
      <Col sm={11} md={10} lg={6}>
        {children}
      </Col>
    </Container>
  );
}

export default ListContainer;
